const tapMiddleware = ({ onSuccess, onError } = {}) => next => (operation, context) =>
	next(operation, context)
		.then(result => {
			try {
				if (typeof onSuccess === "function") onSuccess(operation, result, context);
			} catch (err) {
				// eslint-disable-next-line no-console
				console.error(err);
			}
			return result;
		})
		.catch(error => {
			try {
				if (typeof onError === "function") onError(operation, error, context);
			} catch (err) {
				// eslint-disable-next-line no-console
				console.error(err);
			}
			return Promise.reject(error);
		});

export default tapMiddleware;
